<template>
    <div class="text-left">
        <a v-if="!buttonShow" href="#" class="btn btn-sm btn-light" @click.prevent="handleModal" data-toggle="tooltip" data-placement="left" :title="title">
            <i aria-hidden="true" class="fa fa-clone"></i>
        </a>

        <button v-if="buttonShow" class="btn btn-light" @click.prevent="handleModal">{{ buttonText }}</button>

        <Modal :title="title" :show="showModal" @close="showModal=false">
            <p v-html="message"></p>
            <button class="btn btn-primary" type="submit" ref="submitRef" @click.prevent="firstSubmit">Submit</button>
            <button class="btn btn-link" @click.prevent="showModal=false">Close</button>
        </Modal>

        <Modal :title="secondTitle" :show="secondShowModal" @close="secondShowModal=false">
            <p v-html="secondMessage"></p>
            <button class="btn btn-primary" type="submit" ref="submitRef2" @click.prevent="secondSubmit(1)">Yes</button>
            <button class="btn btn-link" @click.prevent="secondSubmit(0)">No</button>
            <button class="btn btn-link" @click.prevent="secondShowModal=false">Cancel</button>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal";

export default {
    name: "DuplicateModal",
    props: {
        message: { type: String, default: '', required: false },
        route: { type: String, required: true },
        title: { type: String, default: 'Delete', required: false },
        secondMessage: { type: String, default: 'Do you also want to copy the attachments?', required: false },
        secondTitle: { type: String, default: 'Copy attachments', required: false },
        buttonShow: { type: Boolean, default:false, required:false },
        buttonText: { type: String, default: '', required:false},
        tabIdentifier: { type:String, required: true}
    },
    components: {
        Modal,
    },
    data() {
        return {
            showModal: false,
            secondShowModal: false,
        };
    },
    methods: {
        handleModal() {
            this.showModal = true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.submitRef.focus();
                });
            });
        },
        firstSubmit() {
            this.showModal=false;
            this.secondShowModal=true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.submitRef2.focus();
                });
            });
        },
        secondSubmit(value) {
            this.secondShowModal=false;

            if(value) {
                window.location.href=this.route+'?copy-attachments=true&&tab_identifier='+this.tabIdentifier;

                return;
            }

            window.location.href=this.route+'?tab_identifier='+this.tabIdentifier;
        }
    },
}
</script>